module.exports = __webpack_public_path__ + "img/American_Credit_Business_loans_Flexible_Terms.bb0556f.png";